export default "__VITE_ASSET__CTC4ITEs__"